import React, { useReducer, useState, useEffect } from 'react';
import { endOfDay, startOfDay, subDays } from 'date-fns';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import Button from 'jsx/elements/buttons/Button';

import { NotificationsModal } from 'components/NotificationsModal';
import { api } from 'api';
import MonitoringList from './MonitoringList';
import './MonitoringChanges.less';

export default function MonitoringChanges({ monitorId }) {
  const { t, lang } = useLocale();
  const [modalOpen, setModalOpen] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);

  function load() {
    const data = {
      monitorId,
      dateFrom: state.dateFrom.toISOString(),
      dateTo: state.dateTo.toISOString(),
    };
    if (state.search) {
      data.regno = state.search.replace('-', '').replace(' ', '').trim();
    }

    dispatch({ type: 'LOAD_CIP' });
    dispatch({ type: 'LOAD_DD' });
    dispatch({ type: 'LOAD_CIP_STRENGTH' });

    api.dashboard.loadCIPEvents(data).then((cipRes) => {
      if (!cipRes.error) {
        dispatch({ type: 'LOADED_CIP', payload: cipRes });
      }
    });
    api.dashboard.loadDDEvents(data).then((ddRes) => {
      if (!ddRes.error) {
        dispatch({ type: 'LOADED_DD', payload: ddRes });
      }
    });
    api.dashboard.loadCIPStrengthEvents(data).then((cipStrengthRes) => {
      if (!cipStrengthRes.error) {
        dispatch({ type: 'LOADED_CIP_STRENGTH', payload: cipStrengthRes });
      }
    });
  }

  function onFromDateChange(date) {
    dispatch({ type: 'SET_DATE_FROM', payload: date });
  }

  function onToDateChange(date) {
    dispatch({ type: 'SET_DATE_TO', payload: date });
  }

  function onSearchChange(e) {
    dispatch({ type: 'SET_SEARCH', payload: e.target.value });
  }

  useEffect(() => {
    load();
  }, [monitorId, state.dateFrom, state.dateTo]);

  useEffect(() => {
    const allLoaded = state.cipState === 'loaded' && state.ddState === 'loaded';
    if (allLoaded && window.location.hash === '#latest') {
      const el = document.getElementById('latest');
      if (el) el.scrollIntoView();
    }
  }, [state.cipState, state.ddState]);

  return (
    <>
      <div className="dashboard-section-header gutter-top">
        <h2>{t('dashboard_header_monitor')}</h2>
        <Button
          color="gray-light"
          text={lang === 'is' ? 'Tilkynningar' : 'Notifications'}
          onClick={() => setModalOpen(true)}
        />
      </div>
      {modalOpen && <NotificationsModal onClose={() => setModalOpen(false)} />}
      <div id="latest">
        <MonitoringList
          {...state}
          onFromDateChange={onFromDateChange}
          onToDateChange={onToDateChange}
          onSearchChange={onSearchChange}
          onSearchSubmit={load}
        />
      </div>
    </>
  );
}

const initialState = {
  ddEvents: [],
  cipEvents: [],
  cipStrengthEvents: [],
  dateFrom: startOfDay(subDays(new Date(), 1)),
  dateTo: endOfDay(new Date()),
  cipState: 'initial',
  ddState: 'initial',
  cipStrengthState: 'initial',
  search: '',
};

function reducer(state, { type, payload }) {
  switch (type) {
    case 'LOAD_DD':
      return { ...state, ddState: 'loading' };
    case 'LOADED_DD':
      return { ...state, ddEvents: payload, ddState: 'loaded' };
    case 'LOAD_CIP':
      return { ...state, cipState: 'loading' };
    case 'LOADED_CIP':
      return { ...state, cipEvents: payload, cipState: 'loaded' };
    case 'LOAD_CIP_STRENGTH':
      return { ...state, cipStrengthState: 'loading' };
    case 'LOADED_CIP_STRENGTH':
      return { ...state, cipStrengthEvents: payload, cipStrengthState: 'loaded' };
    case 'SET_DATE_FROM':
      return { ...state, dateFrom: startOfDay(payload) };
    case 'SET_DATE_TO':
      return { ...state, dateTo: startOfDay(payload) };
    case 'SET_SEARCH':
      return { ...state, search: payload };
    default:
      return state;
  }
}
